import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Pricings from '../Pricings';
import { COMPONENT_TYPE } from '../Pricings/pricing-constants';
const UpdatePlan = () => {
    const navigate = useNavigate();
    const userDataParsed = localStorage.getItem('diologUserData') ? JSON.parse(localStorage.getItem('diologUserData')) : null;
    useEffect(() => {
        if (!userDataParsed) navigate('/');
    }, [navigate, userDataParsed]);
    return <Pricings componentType={COMPONENT_TYPE.UPDATE} selectedPlan={userDataParsed?.plan} />;
};
export default UpdatePlan;
